import React, { useState, useEffect } from "react";
import { FaChevronDown, FaChevronUp, FaBell, FaTimes, FaCircle, FaCalendarAlt, FaClock } from "react-icons/fa";
import CONFIG from "../config";
import "./Foydalanuvchi.css"; // We'll add modal styles here or in a new file

export default function NotificationModal({ isOpen, onClose }) {
    const [notifications, setNotifications] = useState([]);
    const [expandedId, setExpandedId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [hasRead, setHasRead] = useState(false); // Track if anything was read in this session
    const [isClosing, setIsClosing] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setIsClosing(false);
        }
    }, [isOpen]);

    const fetchNotifications = async () => {
        const token = localStorage.getItem("loyiha_token");
        if (!token) return;
        try {
            const res = await fetch(`${CONFIG.API_BASE_URL}/get_notifications.php`, {
                headers: { 'Authorization': `Bearer ${token}` }
            }).then(r => r.json());
            if (res.status === 'success') {
                setNotifications(res.data);
            }
        } catch (e) {
            console.error("Fetch notifs error:", e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (isOpen) {
            fetchNotifications();
            setHasRead(false); // Reset on open
        }
    }, [isOpen]);

    const formatDateTime = (dateStr) => {
        const d = new Date(dateStr);
        return {
            date: d.toLocaleDateString(),
            time: d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false })
        };
    };

    const handleToggle = async (id, isRead) => {
        if (expandedId === id) {
            setExpandedId(null);
        } else {
            setExpandedId(id);
            if (!isRead) {
                // Mark as read API
                const token = localStorage.getItem("loyiha_token");
                try {
                    const res = await fetch(`${CONFIG.API_BASE_URL}/mark_notification_read.php?id=${id}`, {
                        method: 'POST',
                        headers: { 'Authorization': `Bearer ${token}` }
                    }).then(r => r.json());

                    if (res.status === 'success') {
                        // Refresh local state to hide unread dot
                        setNotifications(prev => prev.map(n => n.id === id ? { ...n, oqildi: 1 } : n));
                        setHasRead(true); // Flag to refresh parent on close
                    }
                } catch (e) {
                    console.error("Mark read error:", e);
                }
            }
        }
    };

    if (!isOpen && !isClosing) return null;

    const handleClose = () => {
        setIsClosing(true);
        setTimeout(() => {
            if (onClose) onClose(hasRead);
            setIsClosing(false);
        }, 300);
    };

    return (
        <div className={`notification-modal-overlay ${isClosing ? 'modal-overlay-fade-out' : 'modal-overlay-fade-in'}`} onClick={handleClose}>
            <div
                className={`notification-modal-content ${isClosing ? 'modal-content-pop-out' : 'modal-content-pop-in'}`}
                onClick={e => e.stopPropagation()}
            >
                <div className="notif-header">
                    <h3><FaBell /> Bildirishnomalar</h3>
                    <button className="notif-close" onClick={handleClose}><FaTimes /></button>
                </div>

                <div className="notif-list-container">
                    {loading ? (
                        <div className="notif-loading">Yuklanmoqda...</div>
                    ) : notifications.length === 0 ? (
                        <div className="notif-empty">
                            <div className="notif-empty-icon"><FaBell /></div>
                            <p>Hozircha xabarlar yo'q</p>
                        </div>
                    ) : (
                        notifications.map(n => {
                            const { date, time } = formatDateTime(n.sana);
                            return (
                                <div key={n.id} className={`notif-item ${expandedId === n.id ? 'active' : ''}`}>
                                    <div className="notif-item-header" onClick={() => handleToggle(n.id, n.oqildi)}>
                                        <div className="notif-title-row">
                                            {!n.oqildi && (
                                                <span className="unread-box">
                                                    <FaCircle className="unread-dot-main" />
                                                    <span className="unread-pulse"></span>
                                                </span>
                                            )}
                                            <span className="notif-title">{n.nomi}</span>
                                        </div>
                                        <div className="notif-meta">
                                            <div className="notif-date-block">
                                                <div className="calendar-icon-wrapper">
                                                    <FaCalendarAlt />
                                                </div>
                                                <div className="notif-date-col">
                                                    <span className="n-date">{date}</span>
                                                    <span className="n-time">{time}</span>
                                                </div>
                                            </div>
                                            {expandedId === n.id ? <FaChevronUp className="chevron-icon" /> : <FaChevronDown className="chevron-icon" />}
                                        </div>
                                    </div>
                                    {expandedId === n.id && (
                                        <div className="notif-item-body">
                                            {n.rasm && (
                                                <div className="notif-image-wrapper">
                                                    <img
                                                        src={`/Rasm/bildirishnoma/${n.rasm}`}
                                                        alt="Bildirishnoma"
                                                        className="notif-image"
                                                        onError={(e) => { e.target.style.display = 'none' }}
                                                    />
                                                </div>
                                            )}
                                            <p>{n.matni}</p>

                                            {/* For demo purposes if no rasm in DB yet, we can show default if hardcoded or just rely on DB */}
                                        </div>
                                    )}
                                </div>
                            );
                        })
                    )}
                </div>
            </div>
        </div>
    );
}
